import React, { useState } from 'react';
import { bool, func, string } from 'prop-types';
import join from 'url-join';

import DuplicateCatalogModal from './modals/DuplicateCatalogModal';
import StatusModal from '../../common/StatusModal';

import useModal from '../../../hooks/useModal';

import http from '../../../util/http';

const api2 = join(import.meta.env.VITE_API2_URL, 'v1');

const DuplicateCatalog = ({ isDuplicateCatalogModalOpen, closeDuplicateCatalogModal, catalogId }) => {
  const [isStatusModalOpen, openStatusModal, closeStatusModal] = useModal();
  const [statusModalProps, setStatusModalProps] = useState({ title: '' });

  const successModalProps = {
    type: 'success',
    title: 'Success:',
    message: 'Your duplicate catalog was successfully created.'
  };

  const errorModalProps = {
    type: 'error',
    title: 'Error:',
    message: 'Your duplicate catalog was unable to be created, please try again.'
  };

  const [isDuplicating, setIsDuplicating] = useState(false);

  const duplicateCatalog = includeProducts => {
    setIsDuplicating(true);
    http
      .post(join(api2, `/catalogs/${catalogId}/duplicate?includeProducts=${includeProducts}`))
      .then(() => {
        setIsDuplicating(false);
        closeDuplicateCatalogModal();
        setStatusModalProps(successModalProps);
        openStatusModal();
      })
      .catch(() => {
        setIsDuplicating(false);
        closeDuplicateCatalogModal();
        setStatusModalProps(errorModalProps);
        openStatusModal();
      });
  };

  return (
    <>
      <DuplicateCatalogModal
        isOpen={isDuplicateCatalogModalOpen}
        closeModal={closeDuplicateCatalogModal}
        duplicateCatalog={duplicateCatalog}
        isDuplicating={isDuplicating}
      />
      <StatusModal isOpen={isStatusModalOpen} closeModal={closeStatusModal} modalProps={statusModalProps} />
    </>
  );
};

DuplicateCatalog.propTypes = {
  isDuplicateCatalogModalOpen: bool.isRequired,
  closeDuplicateCatalogModal: func.isRequired,
  catalogId: string.isRequired
};

export default DuplicateCatalog;
